const URL =
  process.env.NODE_ENV === "production"
    ? "https://propbaseapibeta.azurewebsites.net"
    : "http://localhost:8000";

const constant = {
  baseUrl: URL,
};

export default constant;
